import CognitoRole from "./cognito-role";

export default class CognitoAccount {
  id?: number;
  accountName?: string;
  department?: number;
  position?: number;
  employeeAccountDetails?: CognitoRole[];
  employeeAccountDisciplines?: number[];
}



// WEBPACK FOOTER //
// ./src/models/company-resources/cognito-account.ts